/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Details/Person/Profession/Content",
  onChange
  
}) {
let professionsValueData = fromData.useDataValue({ viewPath,
context: 'professions',
})
let editProfessionalEmployeeProviderResourceTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'edit_professional',
path: 'employee.provider.resource_type.id',
})
let editProfessionalEmployeeProviderResourceTypeIdChangeData = fromData.useDataChange({ viewPath,
context: 'edit_professional',
path: 'employee.provider.resource_type.id',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 size="medium"
 allowEmptyChoice={false}
 data="professions"
 from={professionsValueData}
 data="edit_professional.employee.provider.resource_type.id"
 value={editProfessionalEmployeeProviderResourceTypeIdValueData}
 onChange={editProfessionalEmployeeProviderResourceTypeIdChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Profession"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}